import React from 'react';
import axios from 'axios';
import { Card, Button, Tooltip, Popconfirm, Modal, Carousel, Row, Col } from 'antd';

import facultyLogo from 'images/Faculty-Led.jpg';
import globalLogo from 'images/GlobalStudies.png';
import illuminateLogo from 'images/Illuminate.jpg';
import interconnectLogo from 'images/interconnect.jpg';
import impactLogo from 'images/Impact.png';
import leanInLogo from 'images/LeanIn.png';
import fastPacedLogo from 'images/Fast-Paced.png';
import strenuousLogo from 'images/Strenuous.png';
import photoComingSoon from 'images/coming-soon.png';

import level1Logo from 'images/Level-1.svg';
import level2Logo from 'images/Level-2.svg';
import level3Logo from 'images/Level-3.svg';
import level4Logo from 'images/Level-4.svg';

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import CartButton from './CartButton';

import 'react-quill/dist/quill.snow.css';
import './programCard.css';

// const getFeaturedImage = (program) => {
// 	if (!program.MainImage) return Promise.resolve('');
// 	let mediaURL = program.MainImage;
// 	//mediaURL = apiPath + '/media/' + mediaURL.split('https://www.semesteratsea.org/wp-json/wp/v2/media/')[1];
// 	mediaURL = apiPath.split('/api')[0] + program.MainImage;
// 	if (sessionStorage['fieldProgramImage' + mediaURL]) return Promise.resolve(sessionStorage['fieldProgramImage' + mediaURL]);
// 	return axios.get(mediaURL).then(response => {
// 		sessionStorage.setItem('fieldProgramImage' + mediaURL, mediaURL);
// 		return mediaURL;
// 	});
// }

export default class ProgramCard extends React.Component {
	state = {
		imageURL: null,
		showDetails: false,
		displayInModal: {
			conflicts: "Field Class Conflicts",
			difficulty: "Difficulty",
			duration: "Duration",
			cost_adult: "Standard Program Fee",
			cost_adult_early_booking: "Early Booking Program Fee",
			meals: "Meals Included",
			max_capacity: "Group Size"
		},
		conflicts: null,
		fieldProgramDetailsVisible: false
	}
	// setImageURL = (url) => {
	// 	if (!this._mounted) return;
	// 	this.setState({ imageURL: url });
	// 	if (typeof this.props.onImageLoadSuccess == 'function') this.props.onImageLoadSuccess(this.props.program.Code);
	// }
	// getImageURL = (props) => {
	// 	if (typeof props.onImageLoadAttempt == 'function') props.onImageLoadAttempt(props.program.Code);
	// 	getFeaturedImage(props.program).then(this.setImageURL)
	// 		.catch(error => {
	// 			if (this._imageLoadTries < 3) {
	// 				window.setTimeout(this.getImageURL, 1000 + 50 * props.loadingOtherImages);
	// 			} else {
	// 				console.error('Too many tries, cannot get image for ' + props.program.Code);
	// 				if (this._mounted) this.setState({ imageURL: '' });
	// 			}
	// 		}).then(result => { this._imageLoadTries += 1; });
	// }
	addToCart = () => this.props.onCartAdd(this.props.program)
	removeProgram = () => this.props.onRemoveProgram(this.props.program)
	selectProgram = () => this.props.onSelectProgram(this.props.program)
	cancelGSCEProgram = () => this.props.onCancelGSCEProgram()
	toggleModal = () => { if (this._mounted) this.setState({ showDetails: !this.state.showDetails }); }
	//cancelText = () => {this.props.getCancelText(this.props.program)}



	// loadImageWhenVisible = (props, reset = false) => {
	// 	if (!this._mounted) return;
	// 	if (reset) this.setState({ imageURL: null });
	// 	if ((!this.state.imageURL && this._imageLoadTries < 3) || reset) {
	// 		if (this.imageContainer != null && Math.abs(this.imageContainer.getBoundingClientRect().top) < 2 * window.innerHeight || props.loadingOtherImages === 0) {
	// 			this.getImageURL(props);
	// 		} else {
	// 			window.setTimeout(this.loadImageWhenVisible.bind(this, props, reset), 500 + 100 * props.loadingOtherImages);
	// 		}
	// 	}
	// }
	openFieldProgramDetailsModal = (program) => {
		axios.get(apiPath + '/fieldprogram/conflicts/' + program.CruiseId + '/' + program.Code)
			.then(response => {
				this.setState({ conflicts: response.data, fieldProgramDetailsVisible: true })

				setTimeout(() => {
					this.forceUpdate();//this will fix the carousel boundries
				}, 250);
			}).catch(this.setState({ conflicts: null, fieldProgramDetailsVisible: true }));
	}
	openModalOnInitIfSpecified = () => {
		this.props.TripCode !== null && this.props.TripCode === this.props.program.Code ? this.openFieldProgramDetailsModal(this.props.program) : null;
	}
	closeFieldProgramDetailsModal = () => {
		this.setState({ conflicts: null, fieldProgramDetailsVisible: false });
	}
	currencyFormatter = (value) => {
		var formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',

			// These options are needed to round to whole numbers if that's what you want.
			//minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
			//maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
		});

		return formatter.format(value);
	}
	getCurrentPrice = () => {
		// if(moment(program.StartDateTime) < moment().addDay(-7)){
		// 	return program.EarlyPrice;
		// } //we thought this was used but it doesnt appear to be used - commented to always use max price

		return program.Price;
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.program.Code !== this.props.program.Code) {
			//this._imageLoadTries = 0;
			//this.loadImageWhenVisible(nextProps, true);
			this.setState({ imageURL: apiPath.split('/api')[0] + this.props.program.MainImage });
		}
	}
	componentDidMount() {
		this._mounted = true;
		//this._imageLoadTries = 0;
		//this.loadImageWhenVisible(this.props);
		this.setState({ imageURL: apiPath.split('/api')[0] + this.props.program.MainImage });
		this.openModalOnInitIfSpecified();
	}
	componentWillUnmount() {
		this._mounted = false;
	}

	render() {
		const contentStyle = {
			color: '#fff',
			textAlign: 'center',
			minHeight: '350px',
		};
		const { program, title } = this.props;
		const validEndDate = moment(program.ItemValidEndDate).startOf('day').add(1, 'd').format('YYYY-MM-DD');

		const programDeadlinePassed = validEndDate.length !== 0 ? moment().diff(validEndDate) >= 0 : moment().isAfter('2020-1-4T00:01');
		// const programDeadlinePassed = validEndDate.length !== 0  ? moment().isAfter(validEndDate, 'day') : moment().isAfter('2020-1-4T00:01');
		if (program.ExcursionId === '3174') {
			console.log('programED', moment(program.ItemValidEndDate).format('YYYY-MM-DD'));
			console.log('VED', validEndDate);
			console.log("programDeadline", programDeadlinePassed);
			console.log(moment().format('YYYY-MM-DD'));
		}
		// const programDeadlinePassed = program.ItemValidEndDate.length !== 0  ? moment().isAfter(program.ItemValidEndDate) : moment().isAfter('2020-1-4T00:01')
		//Can edit this for SP19
		const soldOut = parseInt(this.props.availability) === 0;
		const rescoVisible = this.props.rescoItem.visible;
		const rescoDisabled = !this.props.rescoItem.bookable;
		const rescoGSCE = this.props.rescoItem.GSCE;
		const rescoHasNoPrice = !this.props.rescoItem.isCurrentPrice;
		const price = this.props.rescoItem.price;
		const showCartButton = //(typeof this.props.showCartButton !== 'undefined') && this.props.showCartButton
			(rescoHasNoPrice || !rescoVisible || rescoDisabled || programDeadlinePassed) ? false :
				(typeof this.props.showCartButton !== 'undefined') ? this.props.showCartButton :
					true;
		const showSelectButton = (typeof this.props.showSelectButton !== 'undefined') ?
			this.props.showSelectButton : false;
		const showRemoveButton = (typeof this.props.showRemoveButton !== 'undefined') ?
			this.props.showRemoveButton : false;
		const showPrice = (typeof this.props.showPrice !== 'undefined') ?
			this.props.showPrice : true;
		let showSpotsLeft = (typeof this.props.showSpotsLeft !== 'undefined') ?
			this.props.showSpotsLeft : true;

		let classNames = ['programCard'];
		let bannerText = '';
		// console.log('170', this.props)
		if (this.props.showBanners) {
			if (this.props.loading) {
				bannerText = '';
			}
			else if (rescoDisabled && !soldOut) {
				bannerText = 'Cancelled';
			}
			else if (!rescoVisible || programDeadlinePassed) {
				bannerText = 'Registration Closed';
			}
			else if (soldOut && programDeadlinePassed) {
				bannerText = 'Registration Closed';
			}
			else if (soldOut) {
				bannerText = 'Sold Out';
			}
		}
		if (bannerText !== '') classNames.push('unavailable');
		if (this.props.blocked) classNames.push('disabled');
		if (showSpotsLeft) classNames.push('taller');
		if (!program.physical_activity_level) {
			program.physical_activity_level = 0;
		}
		let cardLevel = level1Logo;
		let cardLevelText = "Level 1";
		if (program.physical_activity_level == 2) {
			cardLevel = level2Logo;
			cardLevelText = "Level 2";
		}
		else if (program.physical_activity_level == 3) {
			cardLevel = level3Logo;
			cardLevelText = "Level 3";
		}
		else if (program.physical_activity_level == 4) {
			cardLevel = level4Logo;
			cardLevelText = "Level 4";
		}

		const showDetailsInModal = false;
		//const multiDay = ((typeof program.EndDateTime!== 'undefined') && (program.EndDateTime != program.StartDateTime));
		const multiDay = ((typeof program.EndDateTime !== 'undefined') && (moment(program.EndDateTime).diff(program.StartDateTime, 'days') > 0));
		const imageURL = (program.MainImage !== null) ? apiPath.split('/api')[0] + program.MainImage : photoComingSoon;
		let cancelText = '';
		if (this.props.getCancelText) {
			cancelText = this.props.getCancelText(program);
		}


		return (
			<Card className={classNames.join(' ')}>
				<span className="portDays">
					{multiDay ? 'Days' : 'Day'}
					<br />
					<b>
						{/* {multiDay
							? program.StartDateTime.split('-')[1] + '-' + program.EndDateTime.split('-')[1]
							: program.StartDateTime.split('-')[1]
						} */}
						{multiDay
							? (moment(program.StartDateTime).startOf('day').diff(moment(program.PortArrivalTime).startOf('day'), 'days') + 1) + '-' + (moment(program.EndDateTime).startOf('day').diff(moment(program.PortArrivalTime).startOf('day'), 'days') + 1)
							// ? (moment(program.StartDateTime).diff(program.PortArrivalTime, 'days') + 1) + '-' + (moment(program.EndDateTime).diff(program.PortArrivalTime, 'days') + 1)
							: (moment(program.StartDateTime).startOf('day').diff(moment(program.PortArrivalTime).startOf('day'), 'days') + 1)
							// : (moment(program.StartDateTime).diff(program.PortArrivalTime, 'days') + 1)
						}
					</b>
				</span>

				<a onClick={() => this.openFieldProgramDetailsModal(program)}>
					<div className="photoContainer" ref={c => this.imageContainer = c}>
						<div className="photo" style={(imageURL) ? { backgroundImage: 'url("' + imageURL + '")' } : { border: '1px solid #efefef' }} />
						<span className="unavailableTag">
							{(bannerText === 'Registration Closed') ?
								<Tooltip
									placement="topRight"
									title="The registration deadline for this program has passed. Space may still be available on a case-by-case basis. Please contact the Field Office to inquire.">
									{bannerText}
								</Tooltip> :
								<span>{bannerText}</span>
							}
						</span>
					</div>
				</a>

				<h3 className="title">{title}</h3>

				<div className="excerpt" dangerouslySetInnerHTML={{ __html: program.Summary }} />

				<div className="infoFooter">
					<hr />
					<Row>
						<Col span={7}>
							{showPrice && <span className="price">{(price) ? this.currencyFormatter(price) : ''}</span>}
							{showSpotsLeft && <p>{(this.props.availability) ? this.props.availability + ' left' : ''}</p>}
						</Col>
						<Col span={8} style={{ textAlign: 'center' }}>
							<div className="categoryIcons">
								{false && program.trip_types.indexOf(1989) !== -1 &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>Faculty-Led Programs</div>}>
										<img src={facultyLogo} alt="Faculty-Led Programs" />
									</Tooltip>
								}
								{rescoGSCE &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>Global Studies Credit Eligible</div>}>
										<img src={globalLogo} alt="Global Studies Credit Eligible" />
									</Tooltip>
								}
								{false && (program.trip_types.indexOf(2061) !== -1 || program.trip_types.indexOf(2060) !== -1 || program.trip_types.indexOf(2059) !== -1) &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>ILLUMINATE</div>}>
										<img src={illuminateLogo} alt="ILLUMINATE" />
									</Tooltip>
								}
								{program.trip_types.indexOf(1990) !== -1 &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>IMPACT<br />Program focused on global impact and service</div>}>
										<img src={impactLogo} alt="IMPACT: Program focused on global impact and service" />
									</Tooltip>
								}
								{program.trip_types.indexOf(2587) !== -1 &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>Lean in!<br /> Our most meaningful and unique experiences invite you to engage deeply and take action</div>}>
										<img src={impactLogo} alt="Lean In! Our most meaningful and unique experiences invite you to engage deeply and take action" />
									</Tooltip>
								}
								{false && program.trip_types.indexOf(2057) !== -1 &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>INTERCONNECT</div>}>
										<img src={interconnectLogo} alt="INTERCONNECT" />
									</Tooltip>
								}
								{program.IsLeanIn &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>Lean In!<br /> Our most meaningful and unique experiences invite you to engage deeply and take action</div>}>
										<img src={leanInLogo} alt="Lean In! Our most meaningful and unique experiences invite you to engage deeply and take action" />
									</Tooltip>
								}
								{program.IsStrenuous &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>Strenuous</div>}>
										<img src={strenuousLogo} alt="Strenuous" />
									</Tooltip>
								}
								{program.IsFastPaced &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>Fast Paced</div>}>
										<img src={fastPacedLogo} alt="Fast Paced" />
									</Tooltip>
								}
								{program.physical_activity_level > 0 &&
									<Tooltip placement="bottom" title={
										<div style={{ textAlign: 'center', maxWidth: '150px' }}>{cardLevelText}</div>}>
										<img src={cardLevel} alt={cardLevelText} />
									</Tooltip>
								}

							</div>
						</Col>
						<Col span={9} style={{ textAlign: 'right' }}>
							<span className="tripCode">{program.Code}</span><br />
							{/* {showDetailsInModal?
								<Button onClick={this.toggleModal}>More Details</Button>:
								<a target="_blank" href={program.link}>
									<Button>More Details</Button>
								</a>
							} */}
							{showCartButton && !this.props.blocked &&
								<CartButton
									outOfStock={this.props.availability === '0'}
									programDeadlinePassed={this.props.programDeadlinePassed}
									inCart={this.props.inCart}
									inBooking={this.props.inBooking}
									onClick={this.addToCart} />
							}
							{showSelectButton && !this.props.blocked &&
								<Popconfirm title={<span>Are you sure you want to use your Global Studies Credit on this program?<br />By clicking "Yes" below, you will be registered in the program.<br />Any changes after this point will be handled through the ISE Field Office.</span>}
									okText="Yes" cancelText="No" onConfirm={this.selectProgram}>
									<Button type="primary" disabled={this.props.availability === '0'}>Select</Button>
								</Popconfirm>
							}
							{this.props.variant === 'admin' && this.props.inBooking &&
								<Popconfirm title={<span>Are you sure you want to cancel this Global Studies Credit Eligible program from this booking?</span>}
									okText="Yes" cancelText="No" onConfirm={this.cancelGSCEProgram}>
									<Button type="danger">Cancel</Button>
								</Popconfirm>
							}
							{showRemoveButton &&
								<Popconfirm
									title={cancelText}
									// title={<span>Are you sure you want to cancel this program? By clicking yes below you understand you are releasing your space on this program and will need to re-register if you change your mind. <br /><br/>If payment has been made, a refund will be issued as a credit on Field account (see "Field Payment Status" under "Payments" tab.)</span>}
									okText="Yes" cancelText="No" onConfirm={this.removeProgram}>
									<Button type="danger">Cancel</Button>
								</Popconfirm>
							}
						</Col>
					</Row>
				</div>
				{showDetailsInModal &&
					<Modal
						title={title}
						visible={this.state.showDetails}
						onCancel={this.toggleModal}
						className="printable"
						width={window.innerWidth * (3 / 4)}
						footer={showCartButton && [<CartButton outOfStock={this.props.availability === '0'} inCart={this.props.inCart} inBooking={this.props.inBooking} onClick={this.addToCart} />]}>

						<Button icon="printer" className="printButton" style={{ float: 'right' }} onClick={() => window.print()} />
						<br />

						<Row>
							<Col xs={24} sm={8}><h3>Program Description</h3></Col>
							<Col xs={24} sm={16}><div dangerouslySetInnerHTML={{ __html: program.Summary }} /></Col>
						</Row>
						<Row style={{ marginTop: '8pt' }}>
							<Col xs={24} sm={8}><h3>Program Code</h3></Col>
							<Col xs={24} sm={16}>{program.Code}</Col>
						</Row>
						<Row style={{ marginTop: '8pt' }}>
							<Col xs={24} sm={8}><h3>Program Starts</h3></Col>
							<Col xs={24} sm={16}>Day {program.StartDateTime.split('-')[1]}, {program.StartDateTime}</Col>
						</Row>
						<Row style={{ marginTop: '8pt' }}>
							<Col xs={24} sm={8}><h3>Program Ends</h3></Col>
							<Col xs={24} sm={16}>
								Day {(program.EndDateTime) ? program.EndDateTime.split('-')[1] : program.StartDateTime.split('-')[1]}, {program.EndDateTime}
							</Col>
						</Row>
						{program.acf && Object.keys(program.acf).filter(field => {
							return this.state.displayInModal[field] && typeof program.acf[field] === 'string' && program.acf[field] !== '';
						}).map(field => {
							return (
								<Row key={program.id + '-' + field} style={{ marginTop: '8pt' }}>
									<Col xs={24} sm={8}><h3>{this.state.displayInModal[field]}</h3></Col>
									<Col xs={24} sm={16}>
										{this.state.displayInModal[field].indexOf('Fee') !== -1 && '$'}
										<span dangerouslySetInnerHTML={{ __html: program.acf[field] }} />
									</Col>
								</Row>
							);
						})}
					</Modal>
				}
				{
					<Modal
						title={title}
						visible={this.state.fieldProgramDetailsVisible}
						onCancel={this.closeFieldProgramDetailsModal}
						width={Math.min(window.innerWidth * (3 / 4), 990)}
						footer={null}>
						<div className="container" style={{ margin: "25px 5px" }}>
							<Row id="topSection" gutter={32}>
								<Col span={14} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 14 }}>
									{Object.keys(program.CarouselImages).length > 1 ?
										<Carousel autoplay>
											{Object.entries(program.CarouselImages).map(([key, value]) => {
												return (
													<div key={key} style={contentStyle}>
														<img src={apiPath.split("/api")[0] + value} width="100%" />
													</div>
												)
											})
											}
										</Carousel> :
										<div style={contentStyle} className="single-item-carousel">
											<img src={program.CarouselImages[0] ? program.CarouselImages[0] : imageURL ? imageURL : photoComingSoon} width="100%" />
										</div>
									}
								</Col>
								<Col span={10} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }} className="ql-editor">
									<div id="topRightSection">
										<Row align="middle">
											<Col span={12}>
												<div style={{ backgroundColor: "#CCC", width: "150px", padding: "5px", textAlign: "center", float: "left", marginTop: "6px" }}><h2 style={{ fontWeight: "700" }}>{program.Code}</h2></div>
											</Col>
											<Col span={12}><Button icon="printer" className="printButton" style={{ width: "150px", height: "50px", fontWeight: "700", fontSize: "20px", color: "#000" }} onClick={() => window.print()} size="large">PRINT</Button></Col>
										</Row>
									</div>
									<div id="midRightContentSection" style={{ clear: "both" }}>
										<h2 style={{ marginTop: "20px", marginBottom: "18px", fontWeight: "700", fontSize: "26px" }}>{'Price: ' + this.currencyFormatter(price)}</h2>
										<h3 style={{ marginTop: "4px", fontWeight: "700", fontSize: "18px", lineHeight: "18px" }}>{'Depart: ' + moment(program.StartDateTime).format("MMM DD, YYYY hh:mm A")}</h3>
										<h3 style={{ marginTop: "4px", fontWeight: "700", fontSize: "18px", lineHeight: "18px" }}>{'Return: ' + moment(program.EndDateTime).format("MMM DD, YYYY hh:mm A")}</h3>
										<h3 style={{ marginTop: "4px", fontWeight: "700", fontSize: "18px", lineHeight: "18px" }}>{'Capacity: ' + program.Total}</h3>
										<div style={{ margin: "15px 0" }}>
											{showCartButton && <CartButton outOfStock={this.props.availability === '0'} inCart={this.props.inCart} inBooking={this.props.inBooking} onClick={this.addToCart} buttonSize="large" />}
										</div>
										{program.IsLeanIn || program.IsStrenuous || program.IsFastPaced || program.physical_activity_level > 0 ?
											<ul className="noListStyle programLogoList">
												<li style={{ display: program.IsLeanIn ? "flex" : "none", flexDirection: "row", alignItems: "center", paddingBottom: "5px" }}><img src={leanInLogo} alt="Lean In" width="35" height="26" /><span style={{ fontSize: "14px", fontWeight: "600" }}>&nbsp;Lean In</span></li>
												<li style={{ display: program.IsStrenuous ? "flex" : "none", flexDirection: "row", alignItems: "center", paddingBottom: "5px" }}><img src={strenuousLogo} alt="Strenuous" width="35" height="26" /><span style={{ fontSize: "14px", fontWeight: "600" }}>&nbsp;Strenuous</span></li>
												<li style={{ display: program.IsFastPaced ? "flex" : "none", flexDirection: "row", alignItems: "center" }}><img src={fastPacedLogo} alt="Fast Paced" width="35" height="26" /><span style={{ fontSize: "14px", fontWeight: "600" }}>&nbsp;Fast Paced</span></li>
												<li style={{ display: program.physical_activity_level > 0 ? "flex" : "none", flexDirection: "row", alignItems: "center" }}><img src={cardLevel} alt={cardLevelText} width="35" /><span style={{ fontSize: "14px", fontWeight: "600" }}>&nbsp;{cardLevelText}</span></li>
											</ul> : null
										}
									</div>
								</Col>
							</Row>
							<Row id="bottomSection" gutter={32} style={{ marginTop: "10px" }} className="ql-editor">
								<Col span={14} xs={24} sm={24} md={24} lg={14}>
									<h1 style={{ marginBottom: "5px", fontWeight: "700", fontSize: "36px", lineHeight: "40px" }}>{program.Title}</h1>
									<div dangerouslySetInnerHTML={{ __html: program.Summary }} />
									<br /><br />

									{program.Description && program.Description.length > 0 &&
										<div>
											<h1 style={{ fontWeight: "700", fontSize: "28px", lineHeight: "30px", marginBottom: "5px" }}>Program Description</h1>
											<p dangerouslySetInnerHTML={{ __html: program.Description }} />
											<br />
											<br />
										</div>
									}
									{program.Itinerary && program.Itinerary.length > 0 &&
										<div>
											<h1 style={{ fontWeight: "700", fontSize: "28px", lineHeight: "30px", marginBottom: "5px" }}>Itinerary</h1>
											<p dangerouslySetInnerHTML={{ __html: program.Itinerary }} />
											<br />
											<br />
										</div>
									}
									{program.Inclusions && program.Inclusions.length > 0 &&
										<div>
											<h1 style={{ fontWeight: "700", fontSize: "28px", lineHeight: "30px", marginBottom: "5px" }}>Inclusions</h1>
											<p dangerouslySetInnerHTML={{ __html: program.Inclusions }} />
											<br />
											<br />
										</div>
									}
									{program.Inclusions && program.Inclusions.length > 0 &&
										<div>
											<h1 style={{ fontWeight: "700", fontSize: "28px", lineHeight: "30px", marginBottom: "5px" }}>Notes</h1>
											<p dangerouslySetInnerHTML={{ __html: program.Notes }} />
											<br />
										</div>
									}

								</Col>
								<Col span={10} xs={24} sm={24} md={24} lg={10} className="ql-editor">
									<h3 style={{ fontWeight: "700", fontSize: "18px" }}>Field Class Conflicts</h3>
									<ul style={{ fontSize: "16px" }}>
										{this.state.conflicts ? Object.entries(this.state.conflicts).map(([key, value]) => {
											return (
												<li key={key} style={{ fontSize: "12px" }}>{value}</li>
											)
										}) : <li style={{ fontSize: "12px" }}>No conflicts</li>
										}
									</ul>
								</Col>
							</Row>
							<div style={{ marginTop: "50px" }}>
								{showCartButton && <CartButton outOfStock={this.props.availability === '0'} inCart={this.props.inCart} inBooking={this.props.inBooking} onClick={this.addToCart} />}
							</div>
						</div>
					</Modal>
				}
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/ProgramCardList/ProgramCard.jsx